var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfil(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "colored",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27372 0.999963L6.06912 2.75689",
    stroke: "#00C1F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96973 1.61493L3.97152 3.05475",
    stroke: "#00C1F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.19031L2.54596 4.51783",
    stroke: "#00C1F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.5C9 15.8431 10.3431 14.5 12 14.5H15C16.6569 14.5 18 15.8431 18 17.5V19.5H9V17.5Z",
    fill: "#FC8C41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.5C8 16.8431 9.34315 15.5 11 15.5H13C14.6569 15.5 16 16.8431 16 18.5V19.5H8V18.5Z",
    stroke: "#131416",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.5V4.5C18.2091 4.5 20 6.29086 20 8.5V18.5C20 20.7091 18.2091 22.5 16 22.5H8C5.79086 22.5 4 20.7091 4 18.5V8.5C4 6.29086 5.79086 4.5 8 4.5V4.5",
    stroke: "#131416",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 11,
    r: 2.5,
    fill: "#FC8C41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.5,
    r: 2,
    stroke: "#131416",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2.5,
    width: 8,
    height: 4,
    rx: 2,
    stroke: "#131416",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfil);
export default __webpack_public_path__ + "static/media/profil.0e8ca7b1.svg";
export { ForwardRef as ReactComponent };